<template>
  <v-dialog v-model="dialog" scrollable max-width="90%" width="400px">
    <v-card>
      <v-card-title>
       Chat löschen
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text  style="max-height: 60vh">
       Wollen Sie wirklich den gesamten Chat-Verlauf löschen?
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text @click="dialog = false">{{ $t('cancel') }} </v-btn>
        <v-btn text @click="dialog = false;$emit('deleteChatConfirmed',receiver)">{{ $t('confirm') }} </v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'GroupMemberDialog',
  props: {
    value: { type: Boolean, default: false },
    receiver:Object
  },
  data() {
    return {
      dialog: this.value,
    };
  },
  watch: {
    value(newValue, oldValue) {
      this.dialog = newValue;
    },
    dialog(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('input', newValue);
      }
    },
  },
};
</script>

